// extracted by mini-css-extract-plugin
export var externalLink = "_81-0";
export var internalLinkLabel = "_81-1";